import { IUsersState } from './users/store';
import { usersReducer } from './users/reducer';
import { UsersActions } from './users/actionTypes';
import { IUserSettingsState } from './userSettings/store';
import { userSettingsReducer } from './userSettings/reducer';
import { UserSettingsActions } from './userSettings/actionTypes';
import { IRolesState } from './roles/store';
import { rolesReducer } from './roles/reducer';
import { RolesActions } from './roles/actionTypes';
import { taxonomyReducer, taxonomyCustomerReducer } from './taxonomy/reducer';
import { ITaxonomyCutomerState, ITaxonomyState } from './taxonomy/store';
import { TaxonomyActionTypes } from './taxonomy/actionTypes';
import { ISectionsState } from './sections/store';
import { sectionReducer } from './sections/reducer';
import { ImxUserData } from './roles/types';
import { INotificationsState } from './notifications/store';
import { notificationsReducer } from './notifications/reducer';
import { NotificationsActions } from './notifications/actionTypes';
import { AppStore } from './configureStore';

export interface StoreState {
  users: IUsersState;
  userSettings: IUserSettingsState;
  roles: IRolesState;
  imxUserData?: ImxUserData;
  taxonomy: ITaxonomyState;
  taxonomyCustomer: ITaxonomyCutomerState;
  taxonomyCountryCustomer: ITaxonomyState;
  taxonomyBrand: ITaxonomyState;
  taxonomyOperations: ITaxonomyState;
  taxonomyAssets: ITaxonomyState;
  taxonomyAssetManufacturer: ITaxonomyState;
  taxonomyAddAssetInfo: ITaxonomyState;
  bearingPositions: ITaxonomyState;
  bearings: ITaxonomyState;
  sections: ISectionsState;
  notifications: INotificationsState;
}
export const storeReducers = {
  users: usersReducer,
  userSettings: userSettingsReducer,
  roles: rolesReducer,
  taxonomy: taxonomyReducer,
  taxonomyCustomer: taxonomyCustomerReducer,
  taxonomyCountryCustomer: taxonomyReducer,
  taxonomyBrand: taxonomyReducer,
  taxonomyOperations: taxonomyReducer,
  ITaxonomyState: taxonomyReducer,
  taxonomyAssetManufacturer: taxonomyReducer,
  taxonomyAddAssetInfo: taxonomyReducer,
  bearingPositions: taxonomyReducer,
  bearings: taxonomyReducer,
  sections: sectionReducer,
  notifications: notificationsReducer
};

export type StoreActions =
  | UsersActions
  | UserSettingsActions
  | RolesActions
  | TaxonomyActionTypes
  | TaxonomyActionTypes
  | TaxonomyActionTypes
  | TaxonomyActionTypes
  | TaxonomyActionTypes
  | TaxonomyActionTypes
  | TaxonomyActionTypes
  | TaxonomyActionTypes
  | TaxonomyActionTypes
  | NotificationsActions;

  let _store: AppStore | null = null;
  
  export const setStore = (store: AppStore) => {
    _store = store;
  }

  export const getStore = () => _store;

